module.exports = __webpack_public_path__ + "img/850e9fa82bc98492eef5591c7b287c47.645fcc3e.jpg";